import * as model from './models';

import createAxios from '@framework/http';
const axios = createAxios({ keys: 'userInfo.shopId', DEBUG: process.env.VUE_APP_NODE_ENV !== 'production' });

/** Notify Center Controller  一键清空渠道内所有未读消息 */
export async function clearUnreadUsingPUT(params: { param: model.IClearUnreadNotifyParam }) {
    const result = await axios.put<model.IMessageNotifyOperateResultVO>(
        `/rest/op/vc/merchant/notifyCenter/message/clearUnread`,
        { ...params.param }
    );
    return result;
}

/** Notify Center Controller  查看消息列表 */
export async function listUsingPOST(params: { param: model.INotifyListParam }) {
    const result = await axios.post<model.IMessageNotifyListVO>(`/rest/op/vc/merchant/notifyCenter/message/list`, {
        ...params.param,
    });
    return result;
}

/** Notify Center Controller  读取通知,返回操作结果 */
export async function readUsingPUT(params: { param: model.INotifyReadParam }) {
    const result = await axios.put<model.IMessageNotifyOperateResultVO>(
        `/rest/op/vc/merchant/notifyCenter/message/read`,
        { ...params.param }
    );
    return result;
}

/** Notify Center Controller  查看个人通知设置 */
export async function settingsUsingGET() {
    const result = await axios.get<model.IMessageNotifySettingsVO>(`/rest/op/vc/merchant/notifyCenter/settings`);
    return result;
}

/** Notify Center Controller  修改个人通知设置,只传有修改的配置项,返回操作结果 */
export async function modifySettingsUsingPUT(params: { param: model.IModifyNotifySettingsParam }) {
    const result = await axios.put<model.IMessageNotifyOperateResultVO>(`/rest/op/vc/merchant/notifyCenter/settings`, {
        ...params.param,
    });
    return result;
}

/** Notify Center Controller  短信验证结果回调 */
export async function smsVerifyCallbackUsingPOST(params: { param: model.ISmsVerifyCallbackParam }) {
    const result = await axios.post<model.IMessageSmsVerifyResultVO>(
        `/rest/op/vc/merchant/notifyCenter/smsVerify/callback`,
        { ...params.param }
    );
    return result;
}

/** Notify Center Controller  启动短信验证 */
export async function smsVerifyStartupUsingPOST() {
    const result = await axios.post<model.IMessageSmsVerifyResultVO>(
        `/rest/op/vc/merchant/notifyCenter/smsVerify/startup`
    );
    return result;
}
